import { createAsyncThunk } from "@reduxjs/toolkit";

export const createApiThunk = (type, apiMethod) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    try {
      const response = await apiMethod(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  });
